// extracted by mini-css-extract-plugin
export var hidden = "styles-module--hidden--7f931";
export var mobile_only = "styles-module--mobile_only--0c915";
export var nav_link = "styles-module--nav_link--5a366";
export var navigation = "styles-module--navigation--e77f2";
export var snippet = "styles-module--snippet--e47e4";